import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function knowledgeFormsReducer(state = initialstate.knowledgeForms, action) {
	switch (action.type) {
		case types.GET_ALL_KNOWLEDGE_FORM: {
			if (action.error) {
				return state;
			}

			return {
				...normalize(action.response.cgFormTypeData, 'formID')
			};
		}

		default:
			return state;
	}
}
